import "./styles/statistics.css";
function Statistics() {
  return (
    <div className="statWrapper">
      <div className="statWrapper_row1">
        <p className="statWrapper_row1Title">General statistics:</p>
        <div className="statWrapper_row1_content">
          <div className="statWrapper_row1_content_rightCol">
            <div className="statWrapper_row1_content_leftCol_content">
              <p>Number of Partners:</p>
              <p>356</p>
            </div>
            <div className="statWrapper_row1_content_leftCol_content">
              <p>Total of referred users (all partners)</p>
              <p>642</p>
            </div>
            <div className="statWrapper_row1_content_leftCol_content">
              <p>Total subscriptions coming from referrals (from partners)</p>
              <p>126</p>
            </div>
            <div className="statWrapper_row1_content_leftCol_content">
              <p>Conversion rate</p>
              <p>19.6%</p>
            </div>
          </div>
          <div className="statWrapper_row1_content_leftCol">
            <div className="statWrapper_row1_content_right_content">
              <p>Total referrals revenues (from partners)</p>
              <p>$21,000</p>
            </div>
            <div className="statWrapper_row1_content_right_content">
              <p>Total reward cost</p>
              <p>$9,600</p>
            </div>
            <div className="statWrapper_row1_content_right_content">
              <p>Average reward cost (CAC) </p>
              <p>$26</p>
            </div>
            <div className="statWrapper_row1_content_right_content">
              <p>???</p>
              <p>???</p>
            </div>
          </div>
        </div>
      </div>
      <div className="statWrapper_row2">
        <div className="statWrapper_row2_col1">
          <p className="statWrapper_row2_col1_title">Influencers</p>
          <div className="statWrapper_row2_col1_content">
            <div className="statWrapper_row2_content">
              <p>Number of influencers</p>
              <p>280</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Total of referred users</p>
              <p>380</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Total subscriptions</p>
              <p>98</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Conversion rate</p>
              <p>25.7%</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Total referrals revenues</p>
              <p>$15,000</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Total referrals cost</p>
              <p>$8,000</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Average reward cost (CAC) </p>
              <p>25%</p>
            </div>
          </div>
        </div>
        <div className="statWrapper_row2_col2">
          <p className="statWrapper_row2_col1_title">Agencies</p>
          <div className="statWrapper_row2_col2_content">
            <div className="statWrapper_row2_content">
              <p>Number of agencies</p>
              <p>60</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Total of referred users</p>
              <p>160</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Total subscriptions</p>
              <p>12</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Conversion rate</p>
              <p>25%</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Total referrals revenues</p>
              <p>$8,000</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Total referrals cost</p>
              <p>$5,000</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Average reward cost (CAC) </p>
              <p>$45</p>
            </div>
          </div>
        </div>
        <div className="statWrapper_row2_col3">
          <p className="statWrapper_row2_col1_title">Others</p>
          <div className="statWrapper_row2_col3_content">
            <div className="statWrapper_row2_content">
              <p>Number of other partners</p>
              <p>16</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Total of referred users</p>
              <p>160</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Total subscriptions</p>
              <p>12</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Conversion rate</p>
              <p>25%</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Total referrals revenues</p>
              <p>$8,000</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Total referrals cost</p>
              <p>$5,000</p>
            </div>
            <div className="statWrapper_row2_content">
              <p>Average reward cost (CAC) </p>
              <p>$45</p>
            </div>
          </div>
        </div>
      </div>
      <div className="statWrapper_row3">
        <p className="stateWrapper_row3_title">
          Individuals (excluding partners)
        </p>
        <div className="stateWrapper_row3_content">
          <div className="stateWrapper_row3_content_col1">
            <p className="stateWrapper_row3_content_col1_title">
              All Users (Sum)
            </p>
            <div
              className="stateWrapper_row3_content_col1_content"
              style={{
                marginRight: "50px",
              }}
            >
              <div className="statWrapper_row3_content">
                <p>Total number of users</p>
                <p>3,800</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Number of users using RP</p>
                <p>38</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Total users created from RP</p>
                <p>380</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Total subscriptions from RP</p>
                <p>98</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>RP conversion rate</p>
                <p>25.7%</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Total referrals revenues</p>
                <p>%15,000</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Total referrals cost (value)</p>
                <p>$8,000</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Average reward cost (CAC) </p>
                <p>$15</p>
              </div>
            </div>
          </div>
          <div className="stateWrapper_row3_content_col1">
            <p className="stateWrapper_row3_content_col1_title">
              Subscribed Users
            </p>
            <div
              className="stateWrapper_row3_content_col1_content"
              style={{
                marginRight: "50px",
              }}
            >
              <div className="statWrapper_row3_content">
                <p>Total number of users</p>
                <p>3,800</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Number of users using RP</p>
                <p>38</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Total users created from RP</p>
                <p>380</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Total subscriptions from RP</p>
                <p>98</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>RP conversion rate</p>
                <p>25.7%</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Total referrals revenues</p>
                <p>%15,000</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Total referrals cost (value)</p>
                <p>$8,000</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Average reward cost (CAC) </p>
                <p>$15</p>
              </div>
            </div>
          </div>
          <div className="stateWrapper_row3_content_col1">
            <p className="stateWrapper_row3_content_col1_title">
              Users in Trial Period
            </p>
            <div className="stateWrapper_row3_content_col1_content">
              <div className="statWrapper_row3_content">
                <p>Total number of users</p>
                <p>3,800</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Number of users using RP</p>
                <p>38</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Total users created from RP</p>
                <p>380</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Total subscriptions from RP</p>
                <p>98</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>RP conversion rate</p>
                <p>25.7%</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Total referrals revenues</p>
                <p>%15,000</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Total referrals cost (value)</p>
                <p>$8,000</p>
              </div>
              <div className="statWrapper_row3_content">
                <p>Average reward cost (CAC) </p>
                <p>$15</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Statistics;
